import "./JobTimeline.scss";

import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Job, { JobInfo } from "../../../../../components/job/Job";
import { JobApiRoutes } from "../../../../../shared/api-routes/job/job-api.routes";
import http from "../../../../../shared/utils/http";

const JobTimeline: React.FC = () => {
	// const { isPremiumUserVisible } = useSelector((state: any) => state.Reducer);
	const location = useLocation();
	const [jobs, setJobs] = useState<JobInfo[]>([]);
	const [cursor, setCursor] = useState<string | null>(null);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);
	const loaderRef = useRef<HTMLDivElement | null>(null);

	const onCreateJob = (jobInfo: JobInfo) => {
		setJobs((prev) => [jobInfo, ...prev]);
	};

	const onDeleteJob = (job_id: string) => {
		setJobs((prev) => prev.filter((item) => item.id !== job_id));
	};

	const loadMorePosts = async () => {
		if (loading || !hasMore) return;

		setLoading(true);
		const url = `${JobApiRoutes.GET_ALL_JOBS}?limit=10${
			cursor ? `&cursor=${cursor}` : ""
		}`;

		http.get(url).then((res) => {
			if (res.length === 0) {
				setHasMore(false);
			} else {
				setJobs((prev) => [...prev, ...res]);
				const lastJob = res[res.length - 1];
				setCursor(lastJob.createdAt);
			}
			setLoading(false);
		});
	};

	useEffect(() => {
		if (!loaderRef.current || !hasMore) return;

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting && !loading) {
					loadMorePosts();
				}
			},
			{
				rootMargin: "300px",
			}
		);

		observer.observe(loaderRef.current);

		return () => observer.disconnect();
	}, [loaderRef.current, hasMore, loading]);

	const contentRef = useRef<HTMLDivElement>(null);
	const [leftWidth, setLeftWidth] = useState(50);
	const isDragging = useRef(false);

	const handleMouseMove = (e: MouseEvent) => {
		if (!isDragging.current || !contentRef.current) return;
		const containerWidth = contentRef.current.offsetWidth; // ✅ Safe now
		let newLeftWidth = (e.clientX / containerWidth) * 100;
		if (newLeftWidth < 30) newLeftWidth = 30;
		if (newLeftWidth > 60) newLeftWidth = 60;
		setLeftWidth(newLeftWidth);
	};

	const handleMouseDown = () => {
		isDragging.current = true;
		document.body.style.cursor = "col-resize";
		document.body.style.userSelect = "none";
	};

	const handleMouseUp = () => {
		isDragging.current = false;
		document.body.style.cursor = "default";
		document.body.style.userSelect = "auto";
	};

	useEffect(() => {
		window.addEventListener("mousemove", handleMouseMove);
		window.addEventListener("mouseup", handleMouseUp);
		return () => {
			window.removeEventListener("mousemove", handleMouseMove);
			window.removeEventListener("mouseup", handleMouseUp);
		};
	}, []);

	return (
		<div
			className="grand-container"
			ref={contentRef}
			style={{ "--left-width": `${leftWidth}%` } as React.CSSProperties}
		>
			<div className="job_timeline_container">
				<div className="job-timeline">
					{jobs.map((job: JobInfo, index: number) => (
						<Job
							onDeleteJob={onDeleteJob}
							jobInfo={job}
							key={index}
						/>
					))}
				</div>
				{hasMore && (
					<div
						ref={loaderRef}
						style={{ height: "1px" }}
					/>
				)}
			</div>
			<div
				className="resizer"
				onMouseDown={handleMouseDown}
			></div>
			<Outlet />
		</div>
	);
};

{
	/*<div className="dropdown-div">
  <CustomDropdown
          label="Order by"
          options={[
            { value: "recent", label: "Recent" },
            { value: "relevant", label: "More relevant" },
            ]}
            defaultValue="Recent"
            /> 
</div>; */
}
export default JobTimeline;
